<template>
  <div class="dashboard-page">
    <a-row :gutter="16">
      <a-col v-for="item in statCards" :key="item.key" :xs="24" :sm="12" :md="8" :lg="6">
        <a-card class="stat-card" :bordered="false" hoverable @click="openModule(item)">
          <div class="stat-label">{{ item.label }}</div>
          <div class="stat-value">{{ stats[item.key] || 0 }}</div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getDashboardStats } from '@/api'

export default {
  data() {
    return {
      stats: {},
      statCards: [
        { key: 'productCount', label: '产品数量', path: '/product/list' },
        { key: 'orderCount', label: '订单数量', path: '/order/list' },
        { key: 'customerCount', label: '人员数量', path: '/system/user' },
        { key: 'paidAmount', label: '已支付金额', path: '/order/list', query: { payStatus: '已支付' } },
        { key: 'pendingOrderCount', label: '待发货订单', path: '/order/list', query: { orderStatus: '待发货' } },
        { key: 'pendingInvoiceCount', label: '待开票申请', path: '/order/invoice' },
        { key: 'pendingBomCount', label: '待报价 BOM', path: '/bom/quote' },
        { key: 'visitorCount', label: '浏览人数', path: '/analytics/activity' },
        { key: 'searchProductCount', label: '搜索排名', path: '/analytics/search-ranking' }
      ]
    }
  },
  created() {
    this.loadStats()
  },
  methods: {
    openModule(item) {
      if (item && item.path) this.$router.push({ path: item.path, query: item.query || {} }).catch(() => {})
    },
    loadStats() {
      getDashboardStats().then(res => {
        this.stats = res.data || {}
      })
    }
  }
}
</script>

<style scoped>
.dashboard-page {
  padding: 20px;
  background: #f0f2f5;
  min-height: calc(100vh - 96px);
}
.stat-card {
  margin-bottom: 16px;
  cursor: pointer;
}
.stat-label {
  color: #666;
  font-size: 14px;
}
.stat-value {
  margin-top: 8px;
  color: #111;
  font-size: 28px;
  font-weight: 600;
}
</style>
